<div class="re-flex re-justify-center">
  <button class="re-button re-primary re-w-120 re-mr-30" (click)="sendAnswer.emit('ja')">
    {{ 'satisfactionPoll.answer.yes' | translate }}
  </button>
  <button class="re-button re-secondary re-w-120" (click)="sendAnswer.emit('nein')">
    {{ 'satisfactionPoll.answer.no' | translate }}
  </button>
</div>
